module.exports = __webpack_public_path__ + "static/love-yourself-like-your-life-depends-on-it-a848648ccae17384f5287aac3e3441b7.jpg";